<template>
	<div v-loading="loading" class="positionDe">
		<div class="poHeader" v-if="info">
			<div class="poCon">
				<div class="top">
					<div class="left">
						<div class="name">{{info.position_name}}</div>
						<div class="pay" v-if="info.type=='2'">{{info.salary_part_time_job}}</div>
						<div class="pay"v-else>
							{{`${parseFloat((info.salary_min/1000).toFixed(1))}-${parseFloat((info.salary_max/1000).toFixed(1))}k`}}
						</div>
					</div>
				</div>

				<div class="label">
					<div class="li" v-if="info.tag_name_year">
						{{info.tag_name_year}}
					</div>
					<div class="li" v-if="info.tag_name_qualifications">
						{{info.tag_name_qualifications}}
					</div>
					<div class="li" v-if="info.salary_type">
						{{info.salary_type}}
					</div>
				</div>

				<div class="address">
					<img src="@/static/loction.png" class="icon" />
					<div>
						{{info.address}} {{info.address_details?info.address_details:''}}
					</div>
				</div>
				<div class="buttonG">
					<template v-if="info.status==0">
						<el-button v-if="is_collection==0" type="primary" plain class="buttonL" @click="coll(1)">收藏</el-button>
						<el-button v-else type="primary" @click="coll(2)" class="buttonL">已收藏</el-button>
						<el-button type="primary" class="buttonR" @click="goChat()">沟通职位</el-button>
						<el-button type="primary" class="buttonR" @click="deliver()">{{is_delivery?'已投递简历':'立即投递'}}</el-button>
					</template>
					<el-button v-else type="primary" disabled class="buttonR">暂停招聘</el-button>
				</div>
			</div>

		</div>

		<div class="poCenter" v-if="info">
			<div class="poLeft">
				<div class="poInfo">
					<div class="title">
						职位详情
					</div>
					<div v-if="info.tag_name_others" class="label">
						<div v-for="(item,index) of info.tag_name_others.split(',')" :key="index" class="li">
							{{item}}
						</div>
					</div>
				
					<div class="contentbox" v-if="info.position_welfare_policy">
						<div class="suTitle">福利政策：</div>
						<div class="content">{{info.position_welfare_policy}}</div>
					</div>
					
					<div class="contentbox" v-if="info.position_description">
						<div class="suTitle">职位描述：</div>
						<div class="content">{{info.position_description}}</div>
					</div>
					
					<div class="contentbox" v-if="info.work_time">
						<div class="suTitle">工作时间：</div>
						<div class="content">{{info.work_time}}</div>
					</div>
					
					<div class="contentbox" v-if="info.job_responsibilities">
						<div class="suTitle">工作职责：</div>
						<div class="content">{{info.job_responsibilities}}</div>
					</div>
					
					<div class="contentbox" v-if="info.position_requirement">
						<div class="suTitle">招聘要求：</div>
						<div class="content">{{info.position_requirement}}</div>
					</div>
				</div>

				<div class="tipsbox">
					<div class="title">职位联系人</div>
					<div class="companybox">
						<div class="contacts">
							<el-image class="avatar" :src="info.user.en_avatar||require('@/static/avatar.png')" fit="cover"></el-image>
							<div class="textbox">
								<div>联系人：{{info.user.en_user_name||info.user.user_name}}</div>
								<div>联系方式：{{info.user.phone}}</div>
							</div>
						</div>
						<div class="contacts" style="cursor: pointer;" @click="toCompany()">
							<el-image class="avatar" style="border-radius: 4px;" :src="info.company.logo||require('@/static/company.png')" fit="cover"></el-image>
							<div class="textbox">
								<div>{{info.company.company_name}}</div>
								<div>{{info.company.person_count||'公司规模未知'}}</div>
							</div>
						</div>
					</div>
					
				</div>
				
				<div class="tipsbox">
					<div class="title">准聘 安全提示</div>
					<div class="text">
						准聘严禁用人单位和招聘者用户做出任何损害求职者合法权益的违法违规行为，
						包括但不限于扣押求职者证件、收取求职者财物、向求职者集资、让求职者入股、诱导求职者异地入职、异地参加培训、违法违规使用求职者简历等，
						您一旦发现此类行为， <span @click="openReport()">请立即举报</span>
					</div>
				</div>
			
				<div class="mapbox" v-if="info.lat">
					<div class="title">工作地址</div>
					<div class="map" id="TMap"></div>
				</div>
			</div>

			<downCode></downCode>
		</div>
		
		<el-dialog
			title="举报职位"
			:visible.sync="reportShow"
			:close-on-click-modal="false"
			width="600px">
			<div class="reportBox" v-loading="reportLoading">
				<div class="tips">请详细描述您遇到的问题，并保持您的电话畅通。如有必要，工作人员可能会向您致电取证。</div>
				<div class="inputbox">
					<!-- <div class="label">补充说明</div> -->
					<textarea class="textarea" v-model="reason" placeholder="请详细描述您遇到的问题"></textarea>
				</div>
				
				<div class="inputbox">
					<div class="label">图片说明（最多6张）</div>
					<div class="labelTips">直观的截图是非常有利的举报证据</div>
					<div class="uploadbox">
						<div class="imgbox" v-for="(item,index) in files" :key="index">
							<el-image class="img" :src="createFileUrl(item)" fit="cover"></el-image>
							<i class="el-icon-error delIcon" @click="delFile(index)"></i>
						</div>
						<div class="imgbox upload" v-if="(6-files.length)>0" @click="chooseImage()">
							<input class="input" id="uploadImg" ref="uploadImg" accept="image/*" type="file" :multiple="true" @change="uploadimg"/>
							<i class="el-icon-picture-outline"></i>
						</div>
					</div>
				</div>
				
				<div style="text-align: center;margin-top: 28px;">
					<el-button @click="reportShow = false">取 消</el-button>
					<el-button type="primary" @click="confirmReport()">确 定</el-button>
				</div>
			</div>
			
		</el-dialog>

	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	import AMapLoader from "@amap/amap-jsapi-loader";
	import poDe from '@/components/poDe.vue'
	import {mapKey} from '@/unit/util.js'
	export default {
		components: {
			downCode,
			poDe
		},
		data() {
			return {
				mapKey:mapKey,
				cloLoading:false,
				id: '',
				info: '',
				loading: false,
				is_collection: 0,
				is_delivery: 0,
				is_purchase:0,
				type:1,//1是用户端进入详情 2.公司端进入（没有操作）
				mapContent:null,//地图示例
				reportShow:false,
				reason:'',
				files:[],
				reportLoading:false,
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id
			} else {
				this.$router.go(-1)
			}
			if (this.$route.query.type) {
				this.type = this.$route.query.type
			}
		},
		mounted() {
			if(this.id){
				this.getDetail()
			}
		},
		watch:{
			'$store.state.token':function(val){
				this.getDetail()
			}
		},
		methods: {
			async confirmReport(){
				if(!this.reason) return this.$eltips('请输入您遇到的问题','error')
				let data = {
					position_id:this.info.id,
					reason:this.reason
				}
				this.reportLoading = true
				if(this.files.length>0){
					let tokenRes = await this.$axios.get('/api/client/Common/getQiniuToken')
					if(tokenRes.code!=200) return this.reportLoading = false,this.$eltips('上传失败,请稍后再试','warning');
					let files = []
					for(let i=0;i<this.files.length;i++){
						const keys = 'position-report-'+ this.$util.getStorage('userinfo').id +'-'+i+'-'+ new Date().getTime()
						const qiniuUrl = await this.$util.qiniuUpload(this.files[i],keys,tokenRes.data)
						if(!qiniuUrl) return this.reportLoading = false,this.$util.tips('上传图片失败，请稍后重试');
						files.push(qiniuUrl)
					}
					data.img_url = files.join(',')
				}
				this.$axios.post('/api/client/ES/createComplaints',data).then(res=>{
					this.reportLoading = false
					if(res.code==200){
						this.$eltips(res.msg,'success')
						this.reportShow = false
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			delFile(index){
				this.files.splice(index,1)
			},
			createFileUrl(file){
				const windowURL = window.URL || window.webkitURL;
				return windowURL.createObjectURL(file)
			},
			chooseImage(){
				if(this.files.length>=6) return;
				this.$refs.uploadImg.click()
			},
			uploadimg(e){
				let imgsFiles = e.target.files
				let max = 6 - this.files.length;
				if(imgsFiles.length>max){
					this.$eltips(`最多上传${max}图片`,'error')
					this.$refs['uploadImg'].value = ''
					return ;
				} 
				for(let i=0;i<imgsFiles.length;i++){
					if(!imgsFiles[i].type.startsWith('image/')){
						this.$eltips('仅支持图片格式','error');
						this.$refs['uploadImg'].value = ''
						return 
					} 
				}
				this.files = [...this.files,...imgsFiles]
				this.$refs['uploadImg'].value = ''
			},
			openReport(){
				if(!this.$util.validLogin()) return this.$store.commit('changeLoginDialog', true);
				this.reason = ''
				this.files = []
				this.reportShow = true
			},
			toCompany(){
				this.$router.push({ name: 'companyDe',query: {id:this.info.company.id } });
			},
			mapInit(){
				AMapLoader.load({ "key": this.mapKey,version: "2.0" }).then((AMap) => {
					this.mapContent = new AMap.Map('TMap', {
						viewMode: "2D", //  是否为3D地图模式
						zoom: 15, // 初始化地图级别
						rotateEnable: false,
						dragEnable: false,
						zoomEnable: false,
					});
					let position = new AMap.LngLat(this.info.lng,this.info.lat)
					this.mapContent.setCenter(position,true,)
					this.mapMarker =  new AMap.Marker({
						position: position, 
						label:{
						  content:this.info.address+this.info.address_details,
						  direction:'top'
						}
					});
					this.mapContent.add(this.mapMarker)
				}).catch(e => {
					console.log('地图加载出错-----职位详情',e);
				});
			},
			// 获取详情
			getDetail() {
				this.loading = true
				this.$axios.get('/api/client/Home/getPositionDetails', { params: { id: this.id } }).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.info = res.data
						this.is_collection = res.is_collection
						this.is_delivery = res.is_delivery
						this.is_purchase = res.is_purchase
						if(res.data.lat){
							this.info.lat = parseFloat(this.info.lat)
							this.info.lng = parseFloat(this.info.lng)
							this.mapInit()
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 收藏与取消
			coll(type) {
				if(this.cloLoading) return;
				this.cloLoading = true
				let data = {
					position_id: this.id,
					type: type
				}
				this.$axios.post('/api/client/User/positionCollections', data).then(res => {
					this.cloLoading = false
					if (res.code == 200) {
						if (type == 1) {
							this.is_collection = 1
						}
						if (type == 2) {
							this.is_collection = 0
						}
						this.$eltips(res.msg)
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			//投递
			deliver() {
				if (this.info.is_selected == 1&&this.is_purchase==0) {
					this.$confirm(`该职位是精选职位,需支付${this.info.selected_price}准币进行购买, 是否购买?`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.loading = true
						let data = {
							position_id: this.id
						}
						this.$axios.post('/api/client/User/positionPurchase', data).then(res => {
							this.loading = false
							if (res.code == 200) {
								this.$eltips(res.msg)
								this.deliverRequest()
							} else {
								this.$eltips(res.msg, 'error')
							}
						})
					})
				}else{
					this.deliverRequest()
				}
			},
			deliverRequest(){
				if(this.is_delivery) return;
				this.loading = true
				let data = {
					position_id: this.id
				}
				this.$axios.post('/api/client/User/deliver', data).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.getDetail()
						this.$eltips(res.msg)
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			//聊天
			async goChat() {
				if(!this.$util.validLogin()) return this.$store.commit('changeLoginDialog', true);
				await this.$store.dispatch('checkoutConversation', {
					conversationID:`C2C${this.info.user.en_im_account}`,
					position_id:this.id
				})
				this.$router.push({ name: 'communication'});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.positionDe {
		.poHeader {
			width: 100%;
			background-color: #5E6174;
			padding: 38px 0;
			box-sizing: border-box;
			margin-bottom: 38px;
			.poCon {
				width: 1200px;
				margin: 0 auto 0;
				.label {
					display: flex;
					align-items: center;
					margin-bottom: 20px;

					.li {
						padding: 6px 9px;
						background-color: rgba(245, 245, 245, 0.2);
						border-radius: 4px;
						font-size: 13px;
						color: #fff;
						margin-right: 8px;

						&:last-child {
							margin-right: 0;
						}
					}
				}
				.top {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 20px;
					.left {
						display: flex;
						align-items: center;
						.name {
							margin-right: 42px;
							color: #ffff;
							font-size: 28px;
							max-width: 380px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							display: inline-block;
							vertical-align: middle;
							font-weight: bold;
						}
						.pay {
							color: #FF6666;
							font-size: 32px;
						}
					}
				}

				.address {
					display: flex;
					align-items: center;
					margin-bottom: 20px;

					.icon {
						margin-right: 4px;
						width: 20px;
						height: 20px;
					}

					color: #fff;
					font-size: 14px;
				}

				.buttonG {
					display: flex;
					align-items: center;
					.buttonL {
						padding: 0 48px;
						height: 46px;
						margin-right: 16px;
						font-size: 16px;
						border-radius: 16px;
					}
					.buttonR {
						padding: 0 48px;
						height: 46px;
						margin-right: 16px;
						border-radius: 16px;
						font-size: 16px;
					}
				}
			}

		}

		.poCenter {
			display: flex;
			align-items: flex-start;
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 38px;

			.poLeft {
				margin-right: 16px;
				flex: 1;
				.poInfo {
					margin-bottom: 16px;
					background-color: #FFF;
					padding: 32px;
					border-radius: 16px;
					overflow: hidden;
					.title {
						color: #151515;
						font-size: 22px;
						margin-bottom: 18px;
						font-weight: bold;
					}
					.label {
						display: flex;
						align-items: center;
						margin-bottom: 20px;
						.li {
							padding: 6px 9px;
							background-color: #F5F5F5;
							border-radius: 4px;
							font-size: 13px;
							color: #5E5E5E;
							margin-right: 8px;
					
							&:last-child {
								margin-right: 0;
							}
						}
					}
					.contentbox{
						margin-bottom: 12px;
						.suTitle{
							color: #151515;
							font-size: 16px;
							margin-bottom: 6px;
						}
						.content{
							color: #5E5E5E;
							font-size: 14px;
							white-space: pre-line;
						}
					}
				}
		
				.tipsbox{
					margin-top: 16px;
					padding:16px 32px;
					background: #FFF;
					border-radius: 16px;
					.title{
						font-size: 18px;
						font-weight: bold;
					}
					.text{
						margin-top: 12px;
						font-size: 14px;
						color: #151515;
						text-align: justify;
						line-height: 24px;
						span{
							color: #51A190;
							cursor: pointer;
						}
					}
					.companybox{
						display: flex;
						justify-content: space-between;
						margin-top: 18px;
						.contacts{
							display: flex;
							align-items: center;
							.avatar{
								width: 46px;
								height: 46px;
								border-radius: 50%;
								margin-right: 12px;
							}
							.textbox{
								height: 46px;
								display: flex;
								flex-direction: column;
								justify-content: space-between;
								font-size: 14px;
							}
						}
					}
				}
		
				.mapbox{
					margin-top: 16px;
					padding:16px 32px;
					background: #FFF;
					border-radius: 16px;
					.title{
						font-size: 18px;
						font-weight: bold;
						margin-bottom: 18px;
					}
					.map{
						width: 100%;
						height: 400px;
					}
				}
			}
		}
	}
	
	.reportBox{
		.tips{
			font-size: 14px;
			margin-bottom: 12px;
		}
		.inputbox{
			margin-bottom: 18px;
			.label{
				font-size: 15px;
				font-weight: bold;
				color: #151515;
			}
			.labelTips{
				margin-bottom: 14px;
				color: #5E5E5E;
				font-size: 14px;
			}
			.textarea{
				all: unset;
				box-sizing: border-box;
				width: 100%;
				height: 140px;
				border-radius: 8px;
				font-size: 14px;
				background: #F8F8F8;
				padding: 14px;
				border: 1px solid #F8F8F8;
				color: #151515;
				&:focus{
					border-color: #51A190;
				}
			}
			.uploadbox{
				display: flex;
				flex-wrap: wrap;
				.imgbox{
					width: 88px;
					height: 88px;
					margin-right: 18px;
					margin-bottom: 18px;
					position: relative;
					.img{
						width: 100%;
						height: 100%;
					}
					.delIcon{
						position: absolute;
						right: -7px;
						top: -7px;
					}
				}
				.upload{
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: center;
					border: 1px dashed #ccc;
					position: relative;
					overflow: hidden;
					font-size: 28px;
					&:hover{
						border-color: #51A190;
					}
					.input{
						width: 0;
						height: 0;
						opacity: 0;
					}
				}
			}
		}
	}
</style>